import { useTracking } from '~/composables/useTracking';

export default defineNuxtPlugin(() => {
  const router = useRouter();
  const route = useRoute();

  if (process.client) {
    const { persistClickIds, sendEventToBackend } = useTracking();

    persistClickIds();

    onNuxtReady(() => {
      sendEventToBackend('page_view', {
        page_path: route.path,
        page_title: document.title,
      });
    });

    router.afterEach((to, from) => {
      if (to.path !== from.path) {
        nextTick(() => {
          sendEventToBackend('page_view', {
            page_path: to.path,
            page_title: document.title,
          });
        });
      }
    });
  }
});
